<section class="offline-screen" aria-live="polite">
  <div class="offline-glow offline-glow--top" aria-hidden="true"></div>
  <div class="offline-glow offline-glow--bottom" aria-hidden="true"></div>

  <div class="offline-content">
    <div class="offline-illustration" aria-hidden="true">
      <div class="offline-orbit"></div>
      <div class="offline-globe">
        <span class="globe-continent globe-continent--one"></span>
        <span class="globe-continent globe-continent--two"></span>
      </div>
      <div class="offline-badge-x">×</div>

      <span class="offline-symbol offline-symbol--wifi">◜◜◜</span>
      <span class="offline-symbol offline-symbol--dot">•</span>
      <span class="offline-symbol offline-symbol--ring">◌</span>
      <span class="offline-symbol offline-symbol--cross-one">×</span>
      <span class="offline-symbol offline-symbol--cross-two">×</span>
      <span class="offline-symbol offline-symbol--bang">!</span>
    </div>

    <h1 class="offline-title">You’re currently offline.</h1>
    <p class="offline-subtitle">Check your internet connection and try again.</p>

    <button class="offline-retry-btn" type="button" (click)="retry()" aria-label="Retry">
      <span class="offline-retry-icon" aria-hidden="true">↻</span>
      Retry
    </button>
  </div>
</section>
